import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import * as motion from "motion/react-client"
import { Step1Styles } from './Style'
import { Img } from 'styles/GlobalStyle'
import { StepOne1, StepOne2, Butterfly3, Go2, Butterfly2, Butterfly1, Sun, FinishPath, FinishMessage, PathOne, Like } from 'assets'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { statuses } from 'keys'
import { isEmpty } from 'lodash'
import { AbilityContext, Can } from 'components/Permissions/Can'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { AnimatePresence } from "motion/react"
import { IconButton } from '@mui/material'
import { Pause, PlayArrow } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { screen_5_finish_message_male, screen_5_finish_message_female, screen_1_short_introduction_male, screen_1_short_introduction_female, screen_1_introduction_male, screen_1_introduction_female } from 'record1'
import NextButton from './NextButton'
import ReactPlayer from 'react-player';

const Step1 = () => {
    const { testTaker = {} } = useSelector(state => state.testTaker)
    const { sessionExpired, assessments, setCurrentStep, finishFlag, isMaleGender } = useContext(PerformAssessmentContext)
    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const ability = useContext(AbilityContext)
    const navigate = useNavigate()
    const unCompleteIndex = useRef()
    unCompleteIndex.current = assessments?.findIndex(ass => ass.status == statuses.created || ass.status == statuses.brokenFile)

    const testTakersExpiration = JSON.parse(localStorage.getItem("children-process-expired"))
    const testTakerRef = useRef(testTaker);

    const shortStartAudio = isMaleGender ? screen_1_short_introduction_male : screen_1_short_introduction_female
    const startAudio = isMaleGender ? screen_1_introduction_male : screen_1_introduction_female

    const oneAssessment = [{
        path: PathOne,
        cartoonGif: StepOne1,
        cartoon: StepOne2,
        marginRight: 595,
        width: 1000,
        height: 300,
        autoNextStep: true,
        audio: sessionExpired ? startAudio : shortStartAudio
    }]

    const finishItem = {
        path: FinishMessage,
        cartoonGif: Like,
        cartoon: Like,
        marginRight: 900,
        width: 1000,
        height: 300,
        audio: isMaleGender ? screen_5_finish_message_male : screen_5_finish_message_female,
        hidePlayPause: true,
        autoNextStep: true,
        finish: true
    }

    let item = finishFlag ? finishItem : oneAssessment[0]

    // if (unCompleteIndex.current == -1)
    //     item = finishItem

    const goNextStep = useCallback(() => {
        // if (unCompleteIndex.current == -1)
        if (finishFlag)
            if (ability.can("manage", "student"))
                navigate(app.dashboard)
            else navigate(app.allAssessments)
        else
            setCurrentStep(currentStep => currentStep + 1)
    }, [assessments, finishFlag])

    const handleCartoonSpeaking = useCallback(() => {
        setCartoonSpeaking(cartoonSpeaking => !cartoonSpeaking)
    }, [])

    const nextStep = useCallback(() => {
        setCartoonSpeaking(false)
        setShouldAnimate(true);
        setTimeout(() => {
            goNextStep()
        }, 1500);
    }, [])

    const onEndedPlayer = useCallback(() => {
        // setTimeout(() => {
        item.autoNextStep && nextStep()
        // }, 3000);
    }, [item])

    useEffect(() => {
        testTakerRef.current = testTaker
    }, [testTaker])

    useEffect(() => {
        return (() => {
            const testTaker = testTakerRef.current
            if (!isEmpty(testTaker)) {
                const now = new Date();
                const expirationTime = now.getTime() + 24 * 60 * 60 * 1000; // 1 day in milliseconds
                const testTakerExpiration = {
                    [testTaker.test_taker_id]: expirationTime
                }
                if (sessionExpired) {
                    if (testTakersExpiration != null) {
                        localStorage.setItem("children-process-expired", JSON.stringify({ ...testTakersExpiration, ...testTakerExpiration }))
                    }
                    else {
                        localStorage.setItem("children-process-expired", JSON.stringify(testTakerExpiration))
                    }

                }
            }
        })
    }, [])

    return (
        <Step1Styles pathWidth={item.width} pathHeight={item.height} cartoonMarginRight={item.marginRight}>
            {isEmpty(assessments) ||
                <React.Fragment>
                    <AnimatePresence>
                        <div className='wrap-sun'>
                            {!shouldAnimate ? (
                                <motion.div
                                    exit={{ opacity: 0 }}
                                    initial={{ opacity: 0 }}
                                    animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                    transition={{ duration: 0.7 }}
                                    className='sun'
                                    key="box"
                                >
                                    <div className='sun'>
                                        <Img src={Sun} />
                                    </div>
                                </motion.div>)
                                : null}
                        </div>
                    </AnimatePresence>
                    <AnimatePresence>
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                transition={{ duration: 0.7 }}
                                className='butterfly1'
                                key="butterfly1"
                            >
                                <Img src={Butterfly1} />
                            </motion.div>) : null}
                    </AnimatePresence>
                    <AnimatePresence>
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                transition={{ duration: 0.7 }}
                                className='butterfly2'
                                key="butterfly2"
                            >
                                <Img src={Butterfly2} />
                            </motion.div>) : null}
                    </AnimatePresence>
                    <AnimatePresence>
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                transition={{ duration: 0.7 }}
                                className='butterfly3'
                                key="butterfly3"
                            >
                                <Img src={Butterfly3} />
                            </motion.div>) : null}
                    </AnimatePresence>
                    <AnimatePresence>
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.7 }}
                                className='path-img'
                                key="box"
                            >
                                <Img src={item.path} />
                            </motion.div>) : null}
                    </AnimatePresence>
                    <AnimatePresence>
                        {!shouldAnimate ? (
                            <div className='wrap-cartoon-img'>
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.7 }}
                                    className='cartoon-img'
                                >
                                    <Img src={cartoonSpeaking ? item.cartoonGif : item.cartoon} />
                                    {item.hidePlayPause ||
                                        <div className='play-pause-cartoon'>
                                            <IconButton onClick={handleCartoonSpeaking}>
                                                {cartoonSpeaking ? <Pause color="thirdly" /> : <PlayArrow color="thirdly" />}
                                            </IconButton>
                                        </div>}
                                </motion.div>
                            </div>) : null}
                    </AnimatePresence>
                    <AnimatePresence>
                        <Can I="manage" a="super-user">
                            {!shouldAnimate ? (
                                <motion.div
                                    exit={{ opacity: 0 }}
                                    initial={{ opacity: 0 }}
                                    animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                    transition={{ duration: 0.7 }}
                                >
                                    <div className='wrap-fab-button'>
                                        <NextButton finish={item.finish} action={nextStep} />
                                    </div>
                                </motion.div>) : null}
                        </Can>
                    </AnimatePresence>
                    <ReactPlayer
                        playing={cartoonSpeaking}
                        url={item.audio}
                        controls={true}
                        width='0px' height='0px'
                        onEnded={onEndedPlayer}
                    />
                </React.Fragment>
            }
        </Step1Styles>
    )
}

export default Step1
